import { useSelector } from 'react-redux'

/**
 * Check current user permission on the specified scope
 *
 * @param  {String}   ability   Ability to check
 * @param  {String}   scope     Scope of ability. Can be: club or team
 * @return {Boolean}            Current user permission check result
 */
const usePermission = (ability, scope) => {
  let resource = null

  if (scope === 'club') {
    resource = useSelector((state) => state.clubs.current)
  }

  if (scope === 'team') {
    resource = useSelector((state) => state.team)
  }

  if (resource) {
    return resource.can.includes(ability)
  }

  return false
}

export default usePermission
